<template>
  <ul>
    <li><span>启用</span><span>流程</span></li>
    <li><span><el-switch v-model="translate" active-color="#29c0d5" inactive-color="#fff" @change="switchChange"></el-switch></span><span>翻译</span></li>
    <li><span><el-switch v-model="reviser" active-color="#29c0d5" inactive-color="#fff" @change="switchChange1"></el-switch></span><span>翻译+审校</span></li>
  </ul>
</template>

<script>

export default {
    props: [
    "projectProcessType"
  ],
  data() {
    return {
        translate:true,
        reviser:false,
    };
  },
  created() {
      this.projectProcessType===2 ? this.translate=false : this.translate=true;  // 1.翻译，2.翻译+审校
      this.reviser = !this.translate
  },
  methods: {
  // 开关
  switchChange(data){
      this.translate = data
      this.reviser = !data
      this.$emit('onProgressType', this.translate);
  },
  switchChange1(data){
      this.reviser = data
      this.translate = !data
      this.$emit('onProgressType', this.translate);
  },
}
};
</script>
<style lang="less" scoped>
 ul{
     margin-top: 30px;
     margin-left: 20px;
     float: left;
     text-align: left;
     li{
         margin: 20px 0px;
         span{
             width: 100px;
             display: inline-block;
         }
         span:nth-child(1){
        
         }
         span:nth-child(2){

         }
     }
 }
</style>